import { useAppDispatch, useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';
import {
	updateReasonForCancellation,
	updateStepCeiling,
} from '@acorn-portal/shared/src/store/cancellation/cancellation.slice';
import { ROUTE_PATHS } from '@acorn-portal/shared/src/utils/Routes';
import { useNavigate } from 'react-router';
import { CancellationReasonFormValues } from '../../components/form/cancellation-reason-form';
import { checkCancellationReasonFormChanged } from './check-cancellation-reason-form-changed';

export const useReasonSubmission = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const cancellationState = useAppSelector((state) => state.cancellation);

	const handleSubmit = (values: CancellationReasonFormValues) => {
		const shouldUpdateState = checkCancellationReasonFormChanged(
			{ reason: cancellationState.reasonForCancellation },
			{ reason: values.reason },
		);
		if (shouldUpdateState) {
			// validation will have already passed at this point, so we'll have a valid value
			dispatch(updateReasonForCancellation(values.reason ?? ''));
			dispatch(updateStepCeiling('date'));
		}
		navigate(ROUTE_PATHS.cancellationDate);
	};

	return { handleSubmit };
};
